export const GROUPE_LOCCITANE = 'groupe-loccitane';